import { render, staticRenderFns } from "./IRRFPage.vue?vue&type=template&id=01b78c8f&"
import script from "./IRRFPage.vue?vue&type=script&lang=js&"
export * from "./IRRFPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports